import React, {
    PropTypes,
} from 'react';
import {Row, Col, Alert} from 'react-bootstrap';
import {CustomSelect} from '../../components';
import {UserChange} from '../food/actions';
import {LoadDocs} from './actions';
import {DocsDetails} from './index';
import {connect} from 'react-redux';

class DocsView extends React.Component {
    static propTypes = {
        current: PropTypes.object.isRequired,
        users: PropTypes.array.isRequired,
        UserChange: PropTypes.func.isRequired,
        LoadDocs: PropTypes.func.isRequired,
    };

    onUserChange(key) {
        const {users, UserChange, LoadDocs} = this.props;
        const user = users[key];

        UserChange(user.id, user.fio, user.type);
        LoadDocs(user.id, user.type);
    };

    render() {
        const {current, users, docs} = this.props;
        const {id, type} = current;
        const userChoice = (
            <CustomSelect
                choices={users}
                current={current.id}
                idKey="id"
                emptyValue="Выберите посетителя"
                onChange={this.onUserChange.bind(this)}
                valueKey="fio"
                pic="user"
                className="mb10"
                avatar={(user) => user.photo ?
                    <img className="img-circle" alt={user.fio} width={16}
                         src={"data:image/gif;base64," + user.photo}/> : ''}
            />
        );

        return (
            <div>
                <h3 className="mt5 mb15 text-uppercase" style={{fontWeight: "bold"}}>Документи</h3>
                <Row>
                    <Col lg={8} md={12}>
                        <Row>
                            <Col md={6}>{userChoice}</Col>
                        </Row>
                        {docs.error ? <Alert bsStyle="danger"><p>{docs.error}</p></Alert> : ''}
                        <DocsDetails {...docs} {...{id, type}}/>
                    </Col>
                </Row>
            </div>
        );
    };
}

function mapStateToProps(state) {
    const objects = state.food.objects;
    return {
        users: objects,
        current: state.food.currentUser,
        docs: state.docs
    };
}

export default connect(mapStateToProps, {UserChange, LoadDocs})(DocsView);




/** WEBPACK FOOTER **
 ** ./src/modules/documents/DocsView.js
 **/